<div class="top-visual" [ngClass]="getTopPathClass(currMenu | async)">
  <div class="menu">{{getTopPathName(currMenu | async)}}</div>
  <div class="title">{{getSecondPathName(currMenu | async)}}</div>
</div>

<div class="sub-menu">
  <div class="sub-wrap">
    <ul>
      <li *ngFor="let item of getSecondNode(currMenu | async)['children']">

        <ng-container *ngIf="item.use_yn === '1' && item.viewgroup_slevel <= level && item.viewgroup_elevel >= level">
          <ng-container *ngIf="item.link_open_yn == 'N'">
            <ng-container *ngIf="item.link_url.includes('http'); else route">
              <a [href]="item.link_url" target="_blank">{{item.page_menu_name}}</a>
            </ng-container>
            <ng-template #route>
              <a [routerLink]="item.link_url" target="_blank">{{item.page_menu_name}}</a>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="item.link_open_yn == 'C'">
            <a class="cp" [ngClass]="{active: active_seq == item.seq}" (click)="goLink(item)">{{item.page_menu_name}}</a>
          </ng-container>
        </ng-container>

      </li>
    </ul>
  </div>
</div>

<div class="path inner-wrap">
  <a routerLink="/" class="home">Home</a>
  <span [innerHTML]="getPath( currMenu | async ) | safe : 'html'"></span>
</div>
